(function () {
    const btn = document.getElementById("pdf-button");

    if (btn == null) {
        return;
    }

    btn.addEventListener("click", function () {

        const originalPosition = window.scrollY;

        // Scroll to the top of the page smoothly
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // Wait for the smooth scroll to complete, then print
        setTimeout(() => {
            window.print();

            // Wait until the print dialog is closed and then scroll back smoothly
            setTimeout(() => {
                window.scrollTo({
                    top: originalPosition,
                    behavior: 'smooth'
                });
            }, 150); // This delay may need to be adjusted
        }, 1000); // Adjust this based on the smooth scroll duration

    });
})();


